module.exports = __webpack_public_path__ + "static/media/home.d42bf914.svg";